import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

interface CheckedProps extends SvgProps {
  rectColor?: Colors;
  strokeColor?: Colors;
}

export const Checked = ({
  size = 24,
  rectColor = Colors.blue200,
  strokeColor = Colors.blue700,
  className,
}: CheckedProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill={rectColor} height="14" rx="1.33333" width="14" x="1" y="1" />
      <path
        d="M5 8.00033L7 10.0003L11.3333 5.66699"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
